import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import imageHelper from '@utils/imageHelper';

const Image = styled.img`
  position: absolute;
  z-index: -1;
  top: 0;
  left: -48px;
  height: 98px;
  width: 120px;
  @media (max-width: 70.95em) {
    left: calc(50vw - 37.5px);
    width: 75px;
    height: 60px;
  }
`;

export default function BackgroundImage({ className }) {
  const [width, setWidth] = useState(160);
  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);
  return (
    <Image
      src={imageHelper.getImage('about/quote.png')}
      alt="quotes"
      $width={width}
      className={className}
    />
  );
}

BackgroundImage.defaultProps = {
  className: ''
};

BackgroundImage.propTypes = {
  className: PropTypes.string
};
